import React, { useState } from "react";
import { withNamespaces } from "react-i18next";
import { Col, Container, Row, Spinner } from "reactstrap";
import "./styles.scss";
import PlatformUpdateList from "./PlatformUpdateList";
import { connect } from "react-redux";
import CustomPagination from "../../components/CustomPagination";
import { getActiveModuleInfos } from "src/helpers/module_helper";
import { useQuery } from "@tanstack/react-query";
import SystemUpdateService from "src/apis/SystemUpdateService";
import { toast } from "react-toastify";
import Navigator from "src/components/Navigator";

const PlatformUpdate = (props) => {
    const { t, lng } = props;
    const [ filters, setFilters ] = useState({
        pageIndex: 1,
        pageSize: 25
    });
    const currentModule = getActiveModuleInfos();

    const systemUpdatesQuery = useQuery({
        queryKey: [
            "app-fetch-system-updates",
            filters,
            lng
        ],
        queryFn: async () => {
            return await (SystemUpdateService.getInstance()).fetchList({
                language: lng,
                module: currentModule.id,
                ...filters
            });
        },
        cacheTime: 0,
        refetchOnWindowFocus: false,
        onError: () => {
            toast(t("Failed to load What's New."), {
                type: "error"
            });
        }
    });

    const totalCount = parseInt(systemUpdatesQuery.data?.itemsCount || 0);

    return (
        <div className="page-content platform-updates-page">
            <Container fluid>
                <Row>
                    <Col lg="12" className="mb-4">
                        <Navigator
                            pageTitle="Platform Updates"
                            breadCrumbs={[
                                { title: "SIP", link: "/" },
                                { title: "Platform Updates", link: "#" },
                            ]}
                            translate={true}
                        />
                    </Col>

                    <Col sm="12">
                        {systemUpdatesQuery.isFetching ? (
                            <p className="text-center">
                                <Spinner
                                    animation="border"
                                    variant="primary"
                                    size="sm"
                                    className="me-2"
                                />
                                {t("Loading")}...
                            </p>
                        ) : (
                            <PlatformUpdateList 
                                updates={systemUpdatesQuery.data?.systemUpdates || []}
                            />
                        )}
                    </Col>

                    {totalCount > filters.pageSize && (
                        <Col sm="12">
                            <CustomPagination
                                page={filters.pageIndex}
                                onPageChange={(newPage) => setFilters((currentState) => {
                                    return {
                                        ...currentState,
                                        pageIndex: newPage
                                    }
                                })}
                                pageNumberLimit={7}
                                totalItems={totalCount}
                                setItemsPerPageSelected={(newSize) => setFilters((currentState) => {
                                    return {
                                        ...currentState,
                                        pageSize: newSize
                                    }
                                })}
                                itemsPerPageSelected={filters.pageSize}
                            />
                        </Col>
                    )}

                </Row>
            </Container>
        </div>
    )
}

const mapStatetoProps = (state) => {
    const { Modules } = state;

    return { modules: Modules };
};

export default connect(mapStatetoProps, {})(withNamespaces()(PlatformUpdate));
